import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { GoldPriceService } from 'src/app/services/gold-price.service';

@Pipe({
  name: 'goldRate'
})
export class GoldRatePipe implements PipeTransform {


  constructor(private goldPriceService: GoldPriceService) {
  }

  private cache: { [key: string]: any } = {};



  transform1(metalType: string, weight: number): Observable<number | null> {
    if (!metalType) {
      return of(null);
    }

    if (this.cache[metalType]) {
      return of(this.cache[metalType] * weight);
    }

    return this.goldPriceService.getGoldMetalApi(metalType).pipe(
      map((res: any) => {
        const rate = res;
        this.cache[metalType] = rate;
        return rate * weight;
      }),
      catchError(err => {
        console.error('Error fetching gold rate:', err);
        return of(null);
      })
    );
  }

  private cache$: Observable<any[]> | null = null;

  transform(metalType: string, weight: number = 1): Observable<number | null> {
    if (!metalType) {
      return of(null);
    }

    if (!this.cache$) {
      this.cache$ = this.goldPriceService.getAllMetalRatesDropDown().pipe(
        shareReplay(1),
        catchError(err => {
          console.error('Error fetching gold rates:', err);
          return of([] as any[]);
        })
      );
    }

    return this.cache$.pipe(
      map((allRates: any[]) => {
        const metal = allRates.find(m => m.metal === metalType);
        return metal ? metal.ratePerGram * weight : null;
      })
    );
  }

}
